import React from 'react';
import TextField from 'material-ui/TextField';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentSave from 'material-ui/svg-icons/content/save';
import ContentClear from 'material-ui/svg-icons/content/clear';

import {
    Utils,
    salaService,
} from '../../services';
import PrincipalMaster from '../master/Principal';

class Sala extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editing: false,
            nome: '',
            isPosting: false,
        };
        Utils.showLoading(true);
    }

    async componentWillMount() {
        const form = await salaService.salaForm();
        this.csrfToken = form.token;
        this.formId = form.formId;
        const codigo = this.props.match.params.codigo;
        if (codigo) {
            try {
                const sala = await salaService.getSala(codigo);
                this.setState({
                    editing: true,
                    nome: sala.NOME,
                });
            } catch (error) {
                Utils.showToast(error.message);
            }
        }
        Utils.showLoading(false);
    }

    async onSave(event) {
        event.preventDefault();
        const {
            editing,
            nome,
            isPosting,
        } = this.state;

        if (isPosting) {
            return;
        }

        this.setState({ isPosting: true });
        try {
            let response;
            if (editing) {
                response = await salaService.update({ codigo: +this.props.match.params.codigo, nome, _csrf: this.csrfToken });
            } else {
                response = await salaService.save({ nome, _csrf: this.csrfToken, formId: this.formId });
            }
            Utils.showToast(response.message);
            this.props.history.push('/salas');
        } catch (error) {
            this.setState({ isPosting: false });
            Utils.showToast(error.message);
        }
    }

    render() {
        const {
            nome,
            isPosting,
        } = this.state;

        return (
            <PrincipalMaster title="Sala" {...this.props}>
                <div>
                    <form onSubmit={e => this.onSave(e)}>
                        <div className="padding-content">
                            <TextField
                                name="nome"
                                floatingLabelText="Nome"
                                value={nome}
                                onChange={e => this.setState({ nome: e.target.value })}
                                errorText={nome ? "" : "Campo obrigatório"}
                                fullWidth
                                maxlength={100}
                                required />
                        </div>
                        <div className="fab-buttons">
                            <FloatingActionButton type="submit" disabled={isPosting} style={{ marginRight: 8 }}>
                                <ContentSave />
                            </FloatingActionButton>
                            <FloatingActionButton onClick={() => this.props.history.push('/salas')} backgroundColor="rgb(100, 100, 100)">
                                <ContentClear />
                            </FloatingActionButton>
                        </div>
                    </form>
                </div>
            </PrincipalMaster>
        );
    }
}

export default Sala;
